import {EnquiryByIdAndChassisNumber, EnquiryByQrCode, SearchInput} from '../../Config/dataModel';
import {
    enquiryByIdAndChassisNumber,
    enquiryByQrCode,
    fetchAllInsurers,
    search
} from '../Actions/enquiryAction';

export default (dispatch) => {
    return {
        fetchAllInsurers: () => {
            dispatch(fetchAllInsurers());
        },
        enquiryByIdAndChassisNumber: (data: EnquiryByIdAndChassisNumber) => {
            dispatch(enquiryByIdAndChassisNumber(data));
        },
        enquiryByQrCode: (data: EnquiryByQrCode) => {
            dispatch(enquiryByQrCode(data));
        },
        search: (data: SearchInput) => {
            dispatch(search(data));
        }
    };
};



// WEBPACK FOOTER //
// ./src/ReduxRequests/Dispatch/enquiryDispatch.ts